<app-header-nav></app-header-nav>

<div class="container mx-auto p-6">
  <div class="flex items-center mb-6">
    <button mat-icon-button (click)="onBack()"><mat-icon>arrow_back</mat-icon></button>
    <h1 class="text-2xl font-bold ml-2">My Dashboard</h1>
  </div>

  <div *ngIf="isLoading" class="flex justify-center py-12">
    <mat-spinner></mat-spinner>
  </div>

  <ng-container *ngIf="!isLoading">
    <!-- Summary Cards -->
    <div class="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6" *ngIf="dashboard">
      <mat-card class="text-center p-4">
        <mat-icon class="text-blue-500 mb-2">local_bar</mat-icon>
        <div class="text-2xl font-bold">{{ dashboard.totalVisits }}</div>
        <div class="text-sm text-gray-500">Total Visits</div>
      </mat-card>
      <mat-card class="text-center p-4">
        <mat-icon class="text-green-500 mb-2">payments</mat-icon>
        <div class="text-2xl font-bold">{{ dashboard.totalSpent | currency }}</div>
        <div class="text-sm text-gray-500">Total Spent</div>
      </mat-card>
      <mat-card class="text-center p-4">
        <mat-icon class="text-purple-500 mb-2">calendar_today</mat-icon>
        <div class="text-2xl font-bold">{{ dashboard.lastVisit | date:'mediumDate' }}</div>
        <div class="text-sm text-gray-500">Last Visit</div>
      </mat-card>
      <mat-card class="text-center p-4">
        <mat-icon class="text-yellow-500 mb-2">star</mat-icon>
        <div class="text-2xl font-bold">{{ dashboard.favouriteDrink || 'N/A' }}</div>
        <div class="text-sm text-gray-500">Favourite Drink</div>
      </mat-card>
    </div>

    <!-- Period Filter -->
    <div class="flex items-center gap-4 mb-4">
      <mat-form-field>
        <mat-label>Period</mat-label>
        <mat-select [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange()">
          <mat-option value="WEEK">This Week</mat-option>
          <mat-option value="MONTH">This Month</mat-option>
          <mat-option value="YEAR">This Year</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <mat-tab-group>
      <mat-tab label="Visit History">
        <div class="p-4">
          <div *ngFor="let visit of visitHistory" class="border-b py-3 flex justify-between">
            <div>
              <div class="font-medium">{{ visit.barName || 'Bar Visit' }}</div>
              <div class="text-sm text-gray-500">Table {{ visit.tableNumber }}</div>
            </div>
            <div class="text-right">
              <div class="font-medium">{{ visit.total | currency }}</div>
              <div class="text-sm text-gray-500">{{ visit.createdAt | date:'mediumDate' }}</div>
            </div>
            <button mat-icon-button (click)="openFeedbackDialog(visit.sessionId)">
              <mat-icon>rate_review</mat-icon>
            </button>
          </div>
          <p *ngIf="visitHistory.length === 0" class="text-center text-gray-500 py-8">No visit history</p>
        </div>
      </mat-tab>

      <mat-tab label="Expenditure">
        <div class="p-4">
          <div *ngFor="let item of expenditureHistory" class="border-b py-3 flex justify-between">
            <div class="font-medium">{{ item.date | date:'mediumDate' }}</div>
            <div class="font-bold text-green-600">{{ item.amount | currency }}</div>
          </div>
          <p *ngIf="expenditureHistory.length === 0" class="text-center text-gray-500 py-8">No expenditure data</p>
        </div>
      </mat-tab>
    </mat-tab-group>
  </ng-container>
</div>

<!-- Feedback Dialog -->
<div *ngIf="showFeedbackDialog" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
  <mat-card class="p-6 w-96">
    <h3 class="text-lg font-bold mb-4">Leave Feedback</h3>
    <div class="mb-4">
      <label class="block text-sm mb-2">Rating</label>
      <div class="flex gap-1">
        <button *ngFor="let star of ratingStars" mat-icon-button
          [color]="star <= feedback.overallRating ? 'accent' : ''"
          (click)="feedback.overallRating = star">
          <mat-icon>{{ star <= feedback.overallRating ? 'star' : 'star_border' }}</mat-icon>
        </button>
      </div>
    </div>
    <mat-form-field class="w-full mb-3">
      <mat-label>Your Name (optional)</mat-label>
      <input matInput [(ngModel)]="feedback.customerName">
    </mat-form-field>
    <mat-form-field class="w-full">
      <mat-label>Comment</mat-label>
      <textarea matInput [(ngModel)]="feedback.comments" rows="3"></textarea>
    </mat-form-field>
    <div class="flex justify-end gap-2 mt-4">
      <button mat-button (click)="closeFeedbackDialog()">Cancel</button>
      <button mat-raised-button color="primary" (click)="submitFeedback()">Submit</button>
    </div>
  </mat-card>
</div>

<app-footer></app-footer>
